module.exports = __webpack_public_path__ + "img/newsdetails6.71aa983e.png";